<template>
  <div class="fixed bottom-8 right-2 md:right-8 p-4 bg-wave-crest-50 text-inky-depths-950 rounded-sm">
    <div class="flex items-center gap-2">
      <Icon name="material-cookie-filled" class="w-8 h-8" />
      <p class="text-xl">Choose your cookies</p>
    </div>
    <div class="mt-2 mb-4">
      <p class="font-light">We use cookies to provide the best experience</p>
      <p class="font-light">Read our <NuxtLink class="underline" :to="{ name: 'cookies' }">cookie policy</NuxtLink></p>
    </div>
    <div class="flex flex-col items-center gap-2 font-light">
      <button
        class="w-full px-4 py-2 bg-inky-depths-950 text-wave-crest-50 rounded-sm transition-all hover:bg-inky-depths-800"
        @click="allowCookies">
        Accept cookies
      </button>
      <button
        class="w-full px-4 py-2 border border-inky-depths-950 text-inky-depths-950 rounded-sm transition-all hover:bg-wave-crest-100"
        @click="declineCookies">
        Accept only essential
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { setCookiesEnabled } = useCookies()

const allowCookies = () => {
  setCookiesEnabled(true)
}

const declineCookies = () => {
  setCookiesEnabled(false)
}
</script>
